export default __webpack_public_path__ + "static/media/raykat-color.8d2a491f.svg";